module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drop":"วางไฟล์เพื่ออัพโหลด","btn":{"upload":{"image":"เลือกรูปภาพ","file":"เลือกไฟล์"},"submit":"ยืนยัน","cancel":"ยกเลิก"}},"en":{"drop":"วางไฟล์เพื่ออัพโหลด","btn":{"upload":{"image":"เลือกรูปภาพ","file":"เลือกไฟล์"},"submit":"ยืนยัน","cancel":"ยกเลิก"}}}')
  delete Component.options._Ctor
}
